export const evaultSimulatorABI = [
  {
    type: 'function',
    name: 'getHealthFactor',
    inputs: [
      {
        name: 'evault',
        type: 'address',
        internalType: 'contract IEVault',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'liquidation',
        type: 'bool',
        internalType: 'bool',
      },
    ],
    outputs: [
      {
        name: 'healthFactor',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'simulateHealthFactorAfterWithdraw',
    inputs: [
      {
        name: 'evault',
        type: 'address',
        internalType: 'contract IEVault',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'collateralVault',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'withdrawAmount',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    outputs: [
      {
        name: 'healthFactor',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
] as const
